module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray-a5cf37e9426b22633667e4800527225e.png";